import * as toolkit from 'nuxt-toolkit';

export default (_, inject) => {
  inject('toolkit', toolkit);
};
